import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="terms-container" style={{paddingTop: '5rem'}}>
      <div className="terms-content">
        {/* Header */}
        <div className="terms-header">
          <h1>{t('terms.title')}</h1>
          <p className="terms-date">{t('terms.lastUpdated')}: {t('terms.date')}</p>
        </div>

        {/* Welcome Section */}
        <section className="terms-section">
          <p className="terms-intro">{t('terms.welcome')}</p>
        </section>

        {/* 1. General Terms */}
        <section className="terms-section">
          <h2>{t('terms.section1.title')}</h2>
          <p>{t('terms.section1.content1')}</p>
          <p>{t('terms.section1.content2')}</p>
          <p>{t('terms.section1.content3')}</p>
        </section>

        {/* 2. Products and Services */}
        <section className="terms-section">
          <h2>{t('terms.section2.title')}</h2>
          <p>{t('terms.section2.content1')}</p>
          <ul>
            <li>{t('terms.section2.item1')}</li>
            <li>{t('terms.section2.item2')}</li>
            <li>{t('terms.section2.item3')}</li>
            <li>{t('terms.section2.item4')}</li>
          </ul>
          <p>{t('terms.section2.content2')}</p>
        </section>

        {/* 3. Orders and Payments */}
        <section className="terms-section">
          <h2>{t('terms.section3.title')}</h2>
          <p>{t('terms.section3.content1')}</p>
          <p>{t('terms.section3.content2')}</p>
          <p>{t('terms.section3.content3')}</p>
        </section>

        {/* 4. Shipping and Delivery */}
        <section className="terms-section">
          <h2>{t('terms.section4.title')}</h2>
          <p>{t('terms.section4.content1')}</p>
          <p>{t('terms.section4.content2')}</p>
        </section>

        {/* 5. Returns and Refunds */}
        <section className="terms-section">
          <h2>{t('terms.section5.title')}</h2>
          <p>{t('terms.section5.content1')}</p>
          <ul>
            <li>{t('terms.section5.item1')}</li>
            <li>{t('terms.section5.item2')}</li>
            <li>{t('terms.section5.item3')}</li>
          </ul>
          <p>{t('terms.section5.content2')}</p>
        </section>

        {/* 6. User Accounts */}
        <section className="terms-section">
          <h2>{t('terms.section6.title')}</h2>
          <p>{t('terms.section6.content1')}</p>
          <p>{t('terms.section6.content2')}</p>
          <p>{t('terms.section6.content3')}</p>
        </section>

        {/* 7. Privacy and Data Protection */}
        <section className="terms-section">
          <h2>{t('terms.section7.title')}</h2>
          <p>{t('terms.section7.content1')}</p>
          <p>{t('terms.section7.content2')}</p>
        </section>

        {/* 8. Intellectual Property */}
        <section className="terms-section">
          <h2>{t('terms.section8.title')}</h2>
          <p>{t('terms.section8.content1')}</p>
          <p>{t('terms.section8.content2')}</p>
        </section>

        {/* 9. Limitation of Liability */}
        <section className="terms-section">
          <h2>{t('terms.section9.title')}</h2>
          <p>{t('terms.section9.content1')}</p>
          <p>{t('terms.section9.content2')}</p>
        </section>

        {/* 10. Contact Information */}
        <section className="terms-section">
          <h2>{t('terms.section10.title')}</h2>
          <p>{t('terms.section10.content1')}</p>
          <div className="contact-info">
            <p><strong>{t('terms.section10.email')}:</strong> store@beautypro.ge</p>
            <p><strong>{t('terms.section10.phone')}:</strong> +995 577 188 177</p>
            <p><strong>{t('terms.section10.address')}:</strong> {t('terms.section10.addressValue')}</p>
          </div>
        </section>

        {/* Footer Note */}
        <div className="terms-footer">
          <p>{t('terms.footer')}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;